export default __webpack_public_path__ + "static/media/hero_bottom_vector.dd6d4ab7.svg";